import { Link } from 'react-router-dom';
import './SupervisorBackLink.css';

/** Regreso al tablero del supervisor desde módulos secundarios. */
export default function SupervisorBackLink({ label = 'Volver a tu equipo' }) {
    return (
        <p className="sup-back-wrap">
            <Link to="/" className="sup-back-link">
                ← {label}
            </Link>
        </p>
    );
}
